import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../toast/notify";

export const UPDATE_SYSTEM_MESSAGE = 'UPDATE_SYSTEM_MESSAGE';

export const service = async (data) => {
  const options: object = {
    url: '/Api/Utility/UpdateMessage',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = await callMvcApi(options);
  if (response > 0) {
    mdaeNotfy({message: "Update successful.", messageType:NOTIFY_MESSAGE_TYPE.SUCCESS});
  } else {
    mdaeNotfy({ message: "There was an error updating the message.", messageType: NOTIFY_MESSAGE_TYPE.ERROR});
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(UPDATE_SYSTEM_MESSAGE, service, mock);
